'use strict'

module.exports = require('./html')
